import { Modal, Button, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import faExclamationTriangle from "@fortawesome/fontawesome-free-solid/faExclamationTriangle";

import "../../generic/css/ResponsiveForms.css";
import "../css/SiteCircuitManagement.css";
import "../css/InfoModal.css";
import { useSiteContext } from "../Providers/SSCProvider";
import useApi from "../../../apiProvider";

const RemoveCircuitModal = ({ cicruitModalData, setCicruitModalData }) => {
  const closeModal = () => setCicruitModalData({ show: false });
  const { rebuildHierarchy, setIsLoading, isLoading } = useSiteContext();

  const handleDelete = async () => {
    if (!cicruitModalData.circuit.circuitGmId) return;

    setIsLoading(true);

    try {
      const results = await useApi.removeCircuit(
        cicruitModalData.circuit.circuitGmId
      );
      console.log("results: ", results.returnData);

      rebuildHierarchy({ circuits: results.returnData });
      closeModal();
    } catch (error) {
      console.error("Failed to save circuitNote:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Container>
        <Modal
          show={cicruitModalData.show}
          onHide={closeModal}
          centered
          dialogClassName="custom-modal"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable
        >
          <Modal.Body style={{ overflowY: "auto" }} className="w-150">
            {cicruitModalData.circuit?.status === "Active" ? (
              <>
                <div className="mt-4 mb-4 ps-4">
                  <h4>
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="red"
                      className="me-2"
                    />
                    Active Circuit Cannot Be Deleted
                  </h4>
                  <p>
                    The circuit is currently active. Please update it to a
                    non-active status before deleting.
                  </p>
                </div>
                <Modal.Footer>
                  <Button
                    disabled={isLoading}
                    variant="secondary"
                    onClick={closeModal}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </>
            ) : (
              <>
                <div className="mt-4 mb-4 ps-4">
                  <h4>Confirm Circuit Deletion</h4>
                  <h5>
                    Are you sure you want to delete Circuit:{" "}
                    {cicruitModalData.circuit?.circuitVendorId}?
                  </h5>
                  <p>This action cannot be undone</p>
                </div>
                <Modal.Footer>
                  <Button
                    disabled={isLoading}
                    style={{
                      width: "80px",
                      color: "#707782",
                      backgroundColor: "#E5E7EB",
                      border: "none",
                    }}
                    onClick={closeModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleDelete}
                    style={{
                      width: "80px",
                      color: "#FFFFFF",
                      backgroundColor: "#E02827",
                      border: "none",
                    }}
                  >
                    Delete
                  </Button>
                </Modal.Footer>
              </>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default RemoveCircuitModal;
